export default function isObject(object) {
  return object && typeof object === "object";
}
